import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("bc_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("bc_user", JSON.stringify(data));
    } catch (e) {
      const cached = localStorage.getItem("bc_user");
      if (e?.response?.status === 401 || !cached) {
        localStorage.removeItem("bc_token");
        localStorage.removeItem("bc_user");
        setUser(null);
      } else {
        // Hors-ligne ou serveur injoignable : on garde la session en cache
        try { setUser(JSON.parse(cached)); } catch { setUser(null); }
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("bc_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const demoLogin = async () => {
    const { data } = await api.post("/auth/demo-login");
    localStorage.setItem("bc_token", data.token);
    localStorage.setItem("bc_kiosk", "1");
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("bc_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    ["bc_token", "bc_user", "bc_patient", "bc_care_team", "bc_critical_alerts"].forEach((k) => localStorage.removeItem(k));
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, login, demoLogin, register, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
